export const ON_CASE_UPDATED = `
subscription OnCaseUpdated($case_id: String!) {
        onCaseUpdated(case_id: $case_id) {
          case_id
          type
          timestamp
          data
          metadata
        }
      }
`;
